import moment from 'moment';
import { updateDatePreparationEnded } from 'src/apis/backend';
import Button from 'src/components/Button';
import { ORDER_PHASE_CONTACTING, UNIT } from 'src/constants'
import { MOMENT_FORMAT, MOMENT_UNIT } from 'src/constants/date';

export default function UpdateDatePreparationEnded({ stateDatePrepEnd, setStateDatePrepEnd, minDatePrepEnd, status, updateDatePrepEndDebounceTimer, order, setUpdateDatePrepEndDebounceTimer }) {

    const handleUpdateDatePrepEnd = (value) => {
        const newDateEnd = moment.max(moment(stateDatePrepEnd).add(value, MOMENT_UNIT.MINUTE), minDatePrepEnd);
        setStateDatePrepEnd(newDateEnd);

        if (status === ORDER_PHASE_CONTACTING) return;

        if (updateDatePrepEndDebounceTimer) {
            clearTimeout(updateDatePrepEndDebounceTimer);
        }

        const timer = setTimeout(
            () =>
                updateDatePreparationEnded(
                    order.id,
                    order.chargeId,
                    newDateEnd.format(),
                ),
            1000,
        );
        setUpdateDatePrepEndDebounceTimer(timer);
    };

    return (
        <>
            <div className='d-flex align-items-center justify-content-center'>
                <p
                    className='p-0 text-center'
                    style={{ fontSize: '16px', fontWeight: 'bolder' }}
                >
                    Ajuster l’heure de sortie de cuisine
                </p>
            </div>

            <div className='d-flex align-items-center justify-content-center p-0'>
                <div className='row ml-0 mr-0 mt-1 justify-content-center align-items-center'>
                    <Button
                        color='secondary'
                        outlined
                        padding='sm'
                        minWidth='0px'
                        className='mr-0'
                        style={{ fontSize: UNIT * 0.9375 }}
                        onClick={() => handleUpdateDatePrepEnd(-5)}
                    >
                        - 5
                    </Button>
                    <p className='mx-2 align-self-center m-0 font-weight-bolder'>
                        {moment(stateDatePrepEnd).format(
                            MOMENT_FORMAT.FRENCH_HOUR_TIME,
                        )}
                    </p>
                    <Button
                        color='secondary'
                        outlined
                        padding='sm'
                        minWidth='0px'
                        style={{ fontSize: UNIT * 0.9375 }}
                        onClick={() => handleUpdateDatePrepEnd(5)}
                    >
                        + 5
                    </Button>
                </div>
            </div>
        </>
    )
}
